export const vehicleInfo = {
  vehicleTitle: "CX 727",
  year: "2020",
  validfrom: "12/1/20",
};
